<template>
  <div class="box1">
    <div class="box-bg"></div>
    <div class="con-box">
      <!-- <div class="text-box">
        <p>计算机科学硕士</p>
        <p>数据科学硕士</p>
      </div> -->
      <div class="main-box">
        <div class="text">每年开学3次，分别在1月、5月、8月，申请报名需在相应开学前1至2个月进行资料提交</div>
        <div class="red-text">开学时间可能会有微调<br/>具体以校方公布的时间为准</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  height: 928px;
  background: #fff;
  .box-bg {
    width: 100%;
    height: 640px;
    background: url("../../../assets/coursePage/stevens/box1/banner.png") no-repeat;
    background-size: cover;
    background-position: center;
  }
  .con-box {
    position: absolute;
    bottom: 116px;
    left: 0; 
    right: 0;
    margin: 0 auto;
    width: 670px;
    height: 324px;
    background: transparent;
    border-radius: 32px;
    .text-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        position: relative;
        padding: 20px 0;
        width: 50%;
        font-weight: 600;
        font-size: 34px;
        color: #EBC73C;
        line-height: 48px;
        text-align: center;
      }
      p:first-child {
        &::after {
          position: absolute;
          right: -4px;
          top: 24px;
          content: "";
          width: 4px;
          height: 40px;
          background: #901010;
          border-radius: 1px;
          margin: 0 auto;
        }
      }
    }
  }
  .main-box {
    font-family: PingFangSC, PingFang SC;
    box-sizing: border-box;
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 40px;
    width: 670px;
    background: #FFFFFF;
    box-shadow: 0px 4px 38px 0px rgba(0,0,0,0.08);
    border-radius: 32px;
    .text {
      font-weight: 400;
      font-size: 30px;
      color: #272020;
      line-height: 48px;
      text-align: center;
    }
    .red-text {
      box-sizing: border-box;
      margin-top: 32px;
      padding-top: 24px;
      width: 590px;
      height: 144px;
      background: #FAF3F3;
      border-radius: 13px;
      font-weight: 500;
      font-size: 30px;
      color: #CC0001;
      line-height: 48px;
      text-align: center;
    }
  }
}
</style>
